import { render, staticRenderFns } from "./downloadBtn.vue?vue&type=template&id=5c618bc5&scoped=true&"
import script from "./downloadBtn.vue?vue&type=script&lang=js&"
export * from "./downloadBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c618bc5",
  null
  
)

export default component.exports